import React from 'react';
import {
  ApartmentOutlined, DeploymentUnitOutlined,
  EnvironmentOutlined, FlagOutlined, AimOutlined,
  TableOutlined, GoldOutlined, NodeIndexOutlined,
  FireOutlined, CarryOutOutlined, BlockOutlined,
  NodeExpandOutlined, PullRequestOutlined, BugOutlined,
  ContainerOutlined, TeamOutlined,
} from '@ant-design/icons';

const config = ({ mod }) => ({
  all: {
    label: 'All Subjects',
    items: [
      {
        label: 'Locations',
        key: 'locations',
        link: `/app/${mod}/locations`,
        icon: (
          <EnvironmentOutlined
            width={18}
            height={18}
            style={{ color: 'black' }}
          />
        ),
      },
      {
        label: 'Events',
        key: 'events',
        link: `/app/${mod}/events`,
        icon: (
          <FlagOutlined
            width={18}
            height={18}
            style={{ color: 'black' }}
          />
        ),
      },
      {
        label: 'Stakeholders',
        key: 'stakeholders',
        link: `/app/${mod}/stakeholders`,
        icon: (
          <DeploymentUnitOutlined
            width={18}
            height={18}
            style={{ color: 'black' }}
          />
        ),
      },
      {
        label: 'AllSubjects::Information Relays',
        key: 'network',
        link: `/app/${mod}/lir`,
        icon: (
          <ApartmentOutlined
            width={18}
            height={18}
            style={{ color: 'black' }}
          />
        ),
      },
    ],
  },
  locations: {
    label: 'Locations',
    items: [
      {
        label: 'Mine Sites',
        key: 'mineSites',
        link: `/app/${mod}/scl`,
        icon: (
          <AimOutlined
            width={18}
            height={18}
            style={{ color: 'black' }}
          />
        ),
      },
      {
        label: 'AllSubjects::Towns / Cities',
        key: 'towns',
        link: `/app/${mod}/locations`,
        icon: (
          <TableOutlined
            width={18}
            height={18}
            style={{ color: 'black' }}
          />
        ),
      },
      {
        label: 'Villages',
        key: 'villages',
        link: `/app/${mod}/village`,
        icon: (
          <GoldOutlined
            width={18}
            height={18}
            style={{ color: 'black' }}
          />
        ),
      },
      {
        label: 'Other',
        key: 'other',
        link: `/app/${mod}/locations`,
        icon: (
          <NodeIndexOutlined
            width={18}
            height={18}
            style={{ color: 'black' }}
          />
        ),
      },
    ],
  },
  events: {
    label: 'Events',
    items: [
      {
        label: 'Incidents',
        key: 'incidents',
        link: `/app/${mod}/events?statusFilter=incident`,
        icon: (
          <FireOutlined
            width={18}
            height={18}
            style={{ color: 'black' }}
          />
        ),
      },
      {
        label: 'AllSubjects::Corrective Actions',
        key: 'action',
        link: `/app/${mod}/events?statusFilter=riskMitigationMeasures`,
        icon: (
          <CarryOutOutlined
            width={18}
            height={18}
            style={{ color: 'black' }}
          />
        ),
      },
      {
        label: 'Other',
        key: 'other',
        link: `/app/${mod}/events?statusFilter=other`,
        icon: (
          <BlockOutlined
            width={18}
            height={18}
            style={{ color: 'black' }}
          />
        ),
      },
    ],
  },
  stakeholders: {
    label: 'Stakeholders',
    items: [
      {
        label: 'Mine Operators',
        key: 'mineOperators',
        link: `/app/${mod}/stakeholders`,
        icon: (
          <NodeExpandOutlined
            width={18}
            height={18}
            style={{ color: 'black' }}
          />
        ),
      },
      {
        label: 'Exporters',
        key: 'exporters',
        link: `/app/${mod}/stakeholders`,
        icon: (
          <PullRequestOutlined
            width={18}
            height={18}
            style={{ color: 'black' }}
          />
        ),
      },
      {
        label: 'Local Traders',
        key: 'localTraders',
        link: `/app/${mod}/stakeholders`,
        icon: (
          <BugOutlined
            width={18}
            height={18}
            style={{ color: 'black' }}
          />
        ),
      },
      {
        label: 'Other',
        key: 'other',
        link: `/app/${mod}/stakeholders?type=other`,
        icon: (
          <ContainerOutlined
            width={18}
            height={18}
            style={{ color: 'black' }}
          />
        ),
      },
    ],
  },
  network: {
    label: 'Data Chain Members',
    items: [
      {
        label: 'LIR',
        key: 'lir',
        link: `/app/${mod}/lir`,
        icon: (
          <TeamOutlined
            width={18}
            height={18}
            style={{ color: 'black' }}
          />
        ),
      },
    ],
  },
});

export const DEFAULT_FILTER_VALUE = 'all';

export const filtersConfig = {
  type: 'dropdown',
  settings: {
    options: [
      {
        label: 'Dashboard::All Subjects',
        value: 'all',
      },
      {
        label: 'Locations',
        value: 'locations',
      },
      {
        label: 'Events',
        value: 'events',
      },
      {
        label: 'Stakeholders',
        value: 'stakeholders',
      },
      {
        label: 'AllSubjects::Data Chain',
        value: 'network',
      },
    ],
  },
};

export default config;
